import type { SVGProps } from 'react';
const DawnFlagKN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-KN_svg__a)">
      <path fill="#1EC160" d="M0 10.667 22 0H0z" />
      <path fill="#DF2A40" d="M0 16h22V5.333z" />
      <path fill="#FFD956" d="M.616 20.267 26.38 3.875l-4.996-8.142-25.765 16.393z" />
      <path fill="#262626" d="M-.495 18.458 25.27 2.065l-2.776-4.523-25.765 16.393z" />
      <path
        fill="#fff"
        d="m15.957 6.238-.743 1.198-.482-1.33-1.348-.348 1.092-.878-.09-1.413 1.157.786 1.292-.524-.377 1.363.89 1.09zM7.576 11.411l-.743 1.198-.482-1.329-1.348-.349 1.092-.877-.09-1.414 1.157.787 1.292-.525-.377 1.364.89 1.09z"
      />
    </g>
  </svg>
);
export default DawnFlagKN;
